import { render } from "./pgmx.vue?vue&type=template&id=41f5202b&scoped=true&ts=true"
import script from "./pgmx.vue?vue&type=script&lang=ts"
export * from "./pgmx.vue?vue&type=script&lang=ts"

import "./pgmx.vue?vue&type=style&index=0&id=41f5202b&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f5202b"]])

export default __exports__